import React from "react";
import { useSelector } from "react-redux";
import { Paper, makeStyles, Switch } from "@material-ui/core";
import { IReduxAppState } from "../../reducers";
import IVenueSettings from "../../interfaces/IVenueSettings";
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import { useTranslation } from "react-i18next";
import useCheckPermissions from "../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../const/permissions.const";
import DisabledActionWrapper from "../../yoello-lib/modules/components/DisabledActionWrapper";

export interface IDiscountToggle {}

const useStyles = makeStyles({
  root: {
    padding: "1rem 2rem",
    marginBottom: "2rem",
    display: "flex",
  },
  textWrapper: {
    flex: "1 1 auto",
  },
  title: {
    fontSize: "1rem",
    fontWeight: 600,
  },
  subTitle: {
    fontSize: "1rem",
    color: "#616161",
    fontWeight: 500,
  },
  description: {
    fontSize: "0.9rem",
    color: "#8D98B7",
  },
  switchWrapper: {
    flex: "0 0 10rem",
    justifyContent: "center",
    flexDirection: "column",
    display: "flex",
  },
});

const DiscountToggle = (props: IDiscountToggle) => {
  const classes = useStyles();
  const venueId = useSelector(
    (state: IReduxAppState) => state.selectedVenueId
  )!;
  const {t} = useTranslation()

  const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.DISCOUNT_AND_PROMOTIONS);

  const { callAPI, apiData } = useAPIV2<IVenueSettings>(
    APIExtensions.venueSettings,
    {
      yoelloAPIParams: {
        venue_id: venueId,
        include_disabled: true,
        include_hidden: true,
      },
      dispatcherParams: [venueId],
    }
  );
  const toggleDiscount = (e: any) => {
    callAPI(HTTPMethods.PATCH, {
      query: apiData?.id,
      body: {
        enable_discounts: e.target.checked,
      },
    });
  };

  return (
    <Paper className={classes.root}>
      <div className={classes.textWrapper}>
        <h3 className={classes.title}>{t("square.sync.SquareDiscounts")}</h3>
        <h4 className={classes.subTitle}>{t("square.sync.ActivateDiscounts")}</h4>
        <p className={classes.description}>
        {t("square.sync.SquareDiscountsText")}
        </p>
      </div>
      <div className={classes.switchWrapper}>
        {apiData && (
          <DisabledActionWrapper
            disabled={!hasPermission}
            onDisabledClick={onFailedInteraction}
          >
            <Switch
              defaultChecked={apiData.enable_discounts}
              onChange={toggleDiscount}
              color={"primary"}
              disabled={!hasPermission}
            />
          </DisabledActionWrapper>
          
        )}
      </div>
    </Paper>
  );
};

export default DiscountToggle;
